export default __webpack_public_path__ + "static/media/business-owner.3feff335.svg";